import config from '@config'

import {
    TOGGLE_SIGNAL_DETAIL,
    TOGGLE_SIGNAL_FLAG,
    SIGNALS_OPEN_CIA_NEWS,
    SIGNALS_CIA_NEWS_REQUEST,
    SIGNALS_SET_CIA_NEWS_BTN_DISABLED,
} from './constants'

export const toggleSignalDetail = (module, id, blockKey, customData) => ({
    type: TOGGLE_SIGNAL_DETAIL,
    data: {
        module,
        id,
        blockKey,
        customData,
    },
})

export const toggleSignalFlag = (module, id, blockKey, customData) => ({
    type: TOGGLE_SIGNAL_FLAG,
    data: {
        module,
        id,
        blockKey,
        customData,
    },
})

export const signalsOpenCiaNews = (module, blockKey, id) => ({
    type: SIGNALS_OPEN_CIA_NEWS,
    data: {
        module,
        blockKey,
        id,
    },
})

export const signalsCiaNewsRequest = (opts) => ({
    type: SIGNALS_CIA_NEWS_REQUEST,
    payload: {
        ...config.api.report.syntheticIndicators.ciaNews,
        qs: {
            ...opts,
        },
    },
    optional: {
        skipSessionId: true,
        skipHeaders: true,
    },
})

export const signalsSetCiaNewsBtnDisabled = (module, id, blockKey, customData) => ({
    type: SIGNALS_SET_CIA_NEWS_BTN_DISABLED,
    data: {
        module,
        id,
        blockKey,
        customData,
    },
})
